import { css } from 'lit';

export const styles = css`
  .locations-page {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Header */
  .header {
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .title-section {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .title-section h2 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.5rem;
    font-weight: 600;
  }

  /* Content */
  .content {
    flex: 1;
    padding: 1rem;
    overflow: auto;
    width: 100%;
  }

  .loading-state,
  .error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    gap: 1rem;
  }

  /* Table Styles */
  .table-container {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .table-header h3 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .locations-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: var(--sl-border-radius-medium);
    overflow: hidden;
  }

  .locations-table th {
    background: var(--sl-color-neutral-50);
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .locations-table td {
    padding: 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-100);
    vertical-align: middle;
  }

  .locations-table tr:hover {
    background: var(--sl-color-neutral-50);
  }

  .location-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .location-row:hover {
    background: var(--sl-color-neutral-50);
  }

  .location-name-cell {
    min-width: 200px;
  }

  .column-header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .column-header span {
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }



  /* Ensure filters have enough space */
  .locations-table th {
    min-width: 200px;
  }

  .locations-table th:first-child {
    min-width: 250px;
  }

  .locations-table th:last-child {
    min-width: 80px;
  }

  .empty-state {
    text-align: center;
    padding: 2rem;
    color: var(--sl-color-neutral-500);
  }



  /* Empty State */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    color: var(--sl-color-neutral-500);
    text-align: center;
  }

  .empty-state sl-icon {
    margin-bottom: 1rem;
    color: var(--sl-color-neutral-300);
  }

  /* Modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
  }

  .modal-content {
    background: white;
    border-radius: var(--sl-border-radius-large);
    box-shadow: var(--sl-shadow-x-large);
    max-width: 500px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 1.5rem 0 1.5rem;
    margin-bottom: 1.5rem;
  }

  .modal-header h3 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.25rem;
    font-weight: 600;
  }

  /* Form */
  form {
    padding: 0 1.5rem 1.5rem 1.5rem;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--sl-color-neutral-700);
    font-weight: 500;
    font-size: 0.875rem;
  }

  .form-group sl-input,
  .form-group sl-select,
  .form-group textarea {
    width: 100%;
  }

  .checkbox-label {
    display: flex !important;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0 !important;
  }

  .form-error {
    margin-bottom: 1.5rem;
  }

  .form-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 2rem;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .header-content {
      flex-direction: column;
      align-items: stretch;
    }

      .column-header sl-input,
  .column-header sl-select {
    min-width: 200px;
    width: 100%;
  }

  /* Force filters to maintain their size */
  .locations-table th:first-child {
    min-width: 300px !important;
  }

  .locations-table th:nth-child(2) {
    min-width: 250px !important;
  }

  .locations-table th:nth-child(3) {
    min-width: 200px !important;
  }

  .locations-table th:last-child {
    min-width: 100px !important;
  }

  /* Ensure filters don't shrink - using higher specificity */
  .locations-table .column-header sl-input,
  .locations-table .column-header sl-select {
    min-width: 200px !important;
    width: 100% !important;
    height: 32px !important;
    min-height: 32px !important;
  }

  /* Force table headers to maintain height */
  .locations-table thead th {
    min-height: 80px !important;
    height: auto !important;
    vertical-align: top !important;
    padding: 1rem !important;
  }

  /* Target the actual Shoelace component internals */
  .locations-table .column-header sl-select::part(base) {
    height: 32px !important;
    min-height: 32px !important;
  }

  .locations-table .column-header sl-input::part(base) {
    height: 32px !important;
    min-height: 32px !important;
  }

    .modal-content {
      margin: 1rem;
      max-height: calc(100vh - 2rem);
    }

    .form-actions {
      flex-direction: column;
    }
  }

  @media (max-width: 480px) {
    .card-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .card-badges {
      align-self: flex-start;
    }

    .card-footer {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }
  }
`;
